export default __webpack_public_path__ + "static/media/faq-bg-mob.29769107.png";